import AppointmentInviteContactSection from './AppointmentInviteContactSection';

export default AppointmentInviteContactSection;
